import type { MarketplaceOrderHandoffDefaults } from "@nexus/contracts";

import type { InboxSyncDecision } from "./marketplace-inbox-rows";

export function handoffDefaultsEqual(
  left: MarketplaceOrderHandoffDefaults,
  right: MarketplaceOrderHandoffDefaults,
): boolean {
  return (Object.keys(left) as Array<keyof MarketplaceOrderHandoffDefaults>).every(
    (key) => left[key] === right[key],
  );
}

/** Decide how a settings refetch should interact with in-progress handoff edits. */
export function decideHandoffSync(
  touched: boolean,
  current: MarketplaceOrderHandoffDefaults,
  saved: MarketplaceOrderHandoffDefaults,
): InboxSyncDecision {
  if (touched) return handoffDefaultsEqual(current, saved) ? "mark-pristine" : "keep";
  return handoffDefaultsEqual(current, saved) ? "keep" : "reseed";
}
